import React from "react";
import styles from "./styles.module.css";
import ImageIcons from "../../images/icons-back.png";
import { Link } from "react-router-dom";
import { useParams ,useLocation} from 'react-router-dom';
// import { process.env.REACT_APP_DASHBOARD_URL } from "../../utils/key";

function GettingStarted() {
  const user = useParams();
  console.log(user, "user is");
  const location = useLocation();
  const path = location.pathname.split("/");
  console.log(path[1], "path is");
  const decodedString = atob(path[1]);
  console.log(decodedString.split(" ")[1], "decoded value is");
  const applicationId = decodedString.split(" ")[1];
  const userId = decodedString.split(" ")[0];
  var requestOptions: RequestInit = {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify({user: user.id})
  };

  fetch(`${process.env.REACT_APP_DASHBOARD_URL}/application/send-tnc-mail`, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log(result);
    })
    .catch((error) => console.log("error", error));

  return (
    <div className={styles.main}>
      <img src="/feemonklogo.png" alt="" className={styles.image} />
      <p className={styles.text}>
        Pay your Education Fees in Monthly Installments
      </p>
      <Link to="/login" state={{ applicationId: applicationId,userId:userId }} onClick={() => {
    sessionStorage.setItem('applicationId', applicationId);sessionStorage.setItem('userId', userId);
  }}>
        <button className={styles.button}>
          <img src={ImageIcons} alt="" />
          <span>GET STARTED</span>
        </button>
      </Link>
    </div>
  );
}

export default GettingStarted;
